import receptionDetails from './reception-details.json';
import siteDetails from './site-details.json';

export default {
  siteDetails,
  receptionDetails,
};
